<!-- 取消挂号 成功/失败 -->
<template>
  <a-modal @cancel="openModal(false)" width="700px" :footer="null" :visible="visible" :title="null">
    <div class="reserve-modal">
      <div class="title">
        <div v-if="showPending">
          <span class="title-text">取消预约确认</span>
        </div>
        <div v-else-if="reserve.appointResult">
          <auth-img width="32" height="32" :src="successImg" alt="成功" />
          <span class="title-text">预约挂号取消成功！</span>
        </div>
        <div v-else>
          <auth-img width="32" height="32" :src="failImg" alt="失败" />
          <span class="title-text">预约取消失败</span>
        </div>
      </div>
      <div class="body">
        <div class="item">
          <div class="left">
            <span>医生名称：</span>
            {{ reserve.doctorName }}
          </div>
          <div class="right">
            <span>就诊医院：</span>
            <span>
              {{ reserve.hospitalName }}
            </span>
          </div>
        </div>
        <div class="item">
          <div class="left">
            <span>就诊科室：</span>
            <span>
              {{ reserve.departmentName }}
            </span>
          </div>
          <div class="right">
            <span>就诊时间：</span>
            <span>{{ reserve.visitTime }}</span>
          </div>
        </div>
        <div class="item item-last">
          <div class="left">
            <span>就诊序号：</span>
            <span>{{ reserve.reserveNum }}</span>
          </div>
        </div>
        <!-- 失败原因 -->
        <div v-if="showPending === false && reserve.appointResult === false" class="msg msg-err">
          <div class="tips-top">失败原因：</div>
          <div>
            {{ reserve.appointMessage }}
          </div>
        </div>
        <div class="msg msg-tips">
          <div class="tips-top">请注意：</div>
          <div>
            {{ reserve.blacklistContent }}
          </div>
        </div>
      </div>
      <div class="footer">
        <a-button class="footer-button" @click="openModal(false)">返 回</a-button>
        <a-button
          v-if="showPending"
          class="footer-button"
          @click="cancelReservation"
          type="primary"
        >
          确定取消
        </a-button>
      </div>
    </div>
  </a-modal>
</template>

<script setup>
import successImg from '@/assets/img/saveDone.png'
import failImg from '@/assets/img/saveFail.png'
import { defineProps, defineEmits, reactive, watch, ref } from 'vue'
import { cancelAppoint } from '@/api/chat'
const props = defineProps({
  visible: {
    require: true,
    type: Boolean
  },
  reserveId: {
    require: true,
    type: String
  },
  ucDoctorId: {
    require: true,
    type: String
  },
  curInfo: {
    require: true,
    type: Object
  }
})
const reserve = reactive({
  appointResult: true,
  appointMessage: '取消预约返回为空',
  visitTime: '2024.12.16 周一 下午',
  reserveNum: '2号 13:30',
  visitLocation: '4号楼4楼420诊室',
  appointmentTicketNumber: '6701592',
  patientName: '无欢',
  doctorName: '吴恒',
  hospitalName: '浙江省人民医院',
  departmentName: '孕产保健门诊',
  blacklistContent: '456',
  medicalNotice: '123'
})
// 预约状态·
const showPending = ref(true)

watch(
  () => props.visible,
  show => {
    if (show) {
      showPending.value = true
      initRange()
    }
  }
)

const emits = defineEmits(['update:visible', 'refresh'])
function initRange() {
  const {
    reserveNum,
    visitLocation,
    appointmentTicketNumber,
    patientName,
    doctorName,
    hospitalName,
    department,
    blacklistContent,
    medicalNotice,
    appointReserveStr,
    reserveDate
  } = props.curInfo
  const time = reserveDate.split(' ')[1]

  const params = {
    visitTime: appointReserveStr,
    reserveNum: `${reserveNum}号 ${time}`,
    visitLocation,
    appointmentTicketNumber,
    patientName,
    doctorName,
    hospitalName: `${hospitalName}`,
    departmentName: department,
    blacklistContent,
    medicalNotice
  }
  Object.assign(reserve, params)
}
function cancelReservation() {
  const params = {
    ucDoctorId: props.ucDoctorId,
    reserveId: props.reserveId
  }
  cancelAppoint(params).then(result => {
    Object.assign(reserve, result)
    showPending.value = false
    // if (result.appointResult) {
    emits('refresh')
    // }
  })
}
function openModal(open = true) {
  emits('update:visible', open)
}
</script>
<style lang="scss" scoped>
.reserve-modal {
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    .title-text {
      font-size: 20px;
      color: #262626;
      line-height: 24px;
      margin-left: 12px;
    }
  }
  .body {
    margin-bottom: 24px;
    .item {
      border-bottom: 1px solid #e8e8e8;
      padding: 8px 0;
      display: flex;
      justify-content: space-between;
      .left,
      .right {
        width: 50%;
        text-align: left;
        padding: 12px 0 12px 12px;
      }
      .left {
        border-right: 1px solid #e8e8e8;
      }
    }
    .item-last {
      .left {
        border-right: none;
        width: 100%;
      }
    }
    // 消息提醒
    .msg {
      margin-top: 20px;
      border-radius: 4px;
      padding: 16px 20px;
      white-space: break-spaces;
      .tips-top {
        font-size: 14px;
        font-weight: 700;
      }
    }
    .msg-tips {
      background: #fafafa;
      color: #595959;
    }
    .msg-err {
      color: #ff4848;
      background: #fef2f0;
    }
  }
  .footer {
    border-top: 1px solid #d9d9d9;
    padding-top: 14px;
    text-align: center;
    .footer-button {
      border-radius: 4px;
      margin-right: 12px;
    }
  }
}
</style>
